import { Typography } from '@mui/material';
import { useFormikContext } from 'formik';
import { filter, map } from 'lodash';
import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikArray, P2PProviderSelect } from 'components';
import { TranslationNamespace } from 'i18n';

import { Values } from '../ManageCascade';

type Props = {
  title: string;
  fieldName?: 'p2pProvidersConfigs' | 'payoutP2PProvidersConfigs';
};

export const CascadeP2PProviders: React.FC<Props> = ({
  title,
  fieldName = 'p2pProvidersConfigs',
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.cascades.manage',
  });
  const formik = useFormikContext<Values>();

  return (
    <Fragment>
      <Typography variant="subtitle1">{title}</Typography>
      <FormikArray
        addItemLabel={t('buttons.add_p2p_provider')}
        name={fieldName}
        sortable
        removable
        defaultValue={{ p2pProviderId: '' }}
        ItemComponent={({ item, index }) => {
          const exclude = map(
            filter(
              formik.values[fieldName],
              (config) => config.p2pProviderId !== item.p2pProviderId,
            ),
            (t) => t.p2pProviderId,
          );

          return (
            <P2PProviderSelect
              exclude={exclude}
              ignoreTradeMethodsIds
              hideArchived
              sx={{ mr: 1, flex: 1 }}
              name={`${fieldName}[${index}].p2pProviderId`}
              label={t('fields.p2p_provider')}
            />
          );
        }}
      />
    </Fragment>
  );
};
